import Main from '../components/layout/Main';
import React from 'react';
import MyAccount from "../containers/MyAccount/MyAccount";

const MyAccountPage = () => {
    return <div>
        <Main title="My Account">
            <MyAccount/>
        </Main>
    </div>
}

export default MyAccountPage